module.exports = __webpack_public_path__ + "static/media/MHRP38N0002.31fa36b5.svg";